function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFlagTransition = function SvgFlagTransition(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "flag-transition",
    viewBox: "0 0 351.34 407.01",
    ref: svgRef
  }, props), React.createElement("path", {
    d: "M319.47,45.76c-36.4,14.62-55.06,20.94-117.21,10.17C144.59,46,128.11,7.94,75.6,9.75,39,11,12.59,34.48,0,48.55V380.82c12.56-14.06,39-37.62,75.68-38.89,52.51-1.81,69,36.2,126.66,46.18,62.15,10.77,80.81,4.45,117.21-10.17,15.58-6.26,25.52-12.59,31.79-17.79V27.9C345.07,33.11,335.12,39.47,319.47,45.76Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("g", {
    id: "stripes"
  }, React.createElement("path", {
    d: "M200.48,257.75C175.8,254.47,159.14,247,143,239.86c-19.73-8.79-40.18-17.88-71.44-17.18C43.18,223.32,18.24,234.5,0,245.89V281c14.46-11.38,41.2-28.45,72.16-29.15,25.21-.54,41.24,6.58,59.79,14.84,17.05,7.6,36.37,16.21,64.94,20,64.25,8.54,85.19,3.53,122.81-7.65a181.67,181.67,0,0,0,31.64-12.67V232.91A144.11,144.11,0,0,1,312,251C278.62,260.91,261.86,265.88,200.48,257.75Z",
    style: {
      fill: "#930f2b"
    }
  }), React.createElement("path", {
    d: "M202.32,317.3C177.64,314,161,306.59,144.87,299.41c-19.73-8.79-40.1-17.93-71.44-17.18-29.35.65-55,12.58-73.43,24.35V342c14-11.31,41.69-29.89,74-30.62,25.35-.57,41.26,6.57,59.79,14.83,17.05,7.6,36.37,16.22,65,20,64.25,8.53,85.18,3.53,122.81-7.66a181.8,181.8,0,0,0,29.79-11.72v-33.2a146.07,146.07,0,0,1-37.49,16.86C280.46,320.46,263.71,325.44,202.32,317.3Z",
    style: {
      fill: "#930f2b"
    }
  }), React.createElement("path", {
    d: "M207.9,373.74c-25.32-3.29-42.42-10.72-58.94-17.9-20.25-8.8-41.15-17.95-73.31-17.22-30.28.65-56.77,12.71-75.65,24.54v35.52c14.2-11.29,42.83-30.15,76.25-30.88,26-.55,42.33,6.59,61.35,14.86,17.49,7.61,37.32,16.23,66.63,20,65.92,8.56,87.4,3.56,126-7.61a194.66,194.66,0,0,0,21.11-7.44v-32.1a159.61,159.61,0,0,1-29,11.47C288.07,376.93,270.89,381.91,207.9,373.74Z",
    style: {
      fill: "#930f2b"
    }
  }), React.createElement("path", {
    d: "M199.93,201c-24.68-3.28-41.34-10.71-57.45-17.89-19.73-8.79-40.21-17.92-71.44-17.18-28.12.63-52.85,11.6-71,22.87v35c14.55-11.36,41-28,71.61-28.72,25.18-.54,41.25,6.57,59.79,14.84,17,7.59,36.37,16.21,64.94,20,64.26,8.53,85.19,3.53,122.82-7.65a181,181,0,0,0,32.18-13V175.75a143.37,143.37,0,0,1-39.88,18.45C278.06,204.13,261.31,209.1,199.93,201Z",
    style: {
      fill: "#930f2b"
    }
  }), React.createElement("path", {
    d: "M196.8,151.65c-24.68-3.28-41.34-10.71-57.45-17.89-19.73-8.79-40.19-18-71.44-17.18-26.53.59-50,10.4-67.91,21v34.62C15.1,161,40.1,146.4,68.48,145.76c25.18-.56,41.25,6.58,59.79,14.84,17,7.59,36.37,16.21,64.94,20,64.24,8.55,85.19,3.53,122.82-7.65a179.2,179.2,0,0,0,35.31-14.62v-33.9c-10.17,6.66-25.38,15.21-43,20.45C274.93,154.81,258.15,159.79,196.8,151.65Z",
    style: {
      fill: "#930f2b"
    }
  }), React.createElement("path", {
    d: "M314.21,33.6C280.8,43.53,264,48.51,202.67,40.37,178,37.09,161.34,29.66,145.23,22.48,125.5,13.69,105.12,4.55,73.79,5.3,44.23,6,18.41,18.05,0,29.91V65.39C13.82,54.12,41.75,35.22,74.36,34.48c25.33-.54,41.25,6.58,59.79,14.84,17,7.6,36.37,16.21,64.94,20,64.23,8.54,85.17,3.53,122.81-7.65a182.36,182.36,0,0,0,29.44-11.55V17A146.64,146.64,0,0,1,314.21,33.6Z",
    style: {
      fill: "#930f2b"
    }
  }), React.createElement("path", {
    d: "M202.7,96.53c-24.68-3.28-41.34-10.7-57.45-17.88-19.72-8.79-40.11-17.94-71.44-17.18C44.24,62.13,18.41,74.23,0,86.09v35.49c13.81-11.27,41.75-30.2,74.39-30.93,25.33-.54,41.25,6.57,59.78,14.83,17.05,7.61,36.37,16.22,64.94,20,64.24,8.53,85.18,3.52,122.82-7.65a181.39,181.39,0,0,0,29.41-11.55V73.17a146.84,146.84,0,0,1-37.11,16.6C280.83,99.7,264.05,104.67,202.7,96.53Z",
    style: {
      fill: "#930f2b"
    }
  })), React.createElement("g", {
    id: "stars"
  }, React.createElement("path", {
    d: "M152.73,23.79C89.13.44,91.88-.53,73,.13,38.72,1.34,13.42,17.16,0,28V188.77c18.19-11.27,42.92-22.24,71-22.87,31.23-.74,51.71,8.39,71.44,17.18,6.24,2.79,12.58,5.6,19.42,8.2L164,29.38C162.64,29.05,152.73,23.79,152.73,23.79Z",
    style: {
      fill: "#0d1a99"
    }
  }), React.createElement("g", null, React.createElement("polygon", {
    points: "19.42 86.29 23.26 94.67 32.08 96.12 25.6 102.52 26.98 111.69 19.14 107.26 11.18 111.48 12.81 102.35 6.5 95.78 15.36 94.56 19.42 86.29",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "51.6 69.83 55.44 78.21 64.26 79.67 57.78 86.06 59.17 95.23 51.32 90.81 43.36 95.02 44.99 85.89 38.69 79.32 47.54 78.11 51.6 69.83",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "82.5 71.46 86.34 79.84 95.16 81.29 88.68 87.68 90.06 96.86 82.22 92.43 74.26 96.64 75.89 87.51 69.58 80.95 78.44 79.73 82.5 71.46",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "110.11 77.12 113.94 85.5 122.76 86.96 116.28 93.35 117.67 102.52 109.82 98.09 101.86 102.31 103.49 93.18 97.19 86.61 106.04 85.4 110.11 77.12",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "139.91 80.97 143.75 89.35 152.57 90.81 146.09 97.2 147.48 106.37 139.63 101.94 131.67 106.16 133.3 97.03 126.99 90.46 135.85 89.25 139.91 80.97",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "19.05 113.88 22.89 122.26 31.71 123.72 25.23 130.11 26.61 139.28 18.77 134.86 10.81 139.07 12.44 129.94 6.13 123.37 14.99 122.16 19.05 113.88",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "16.98 144.9 20.82 153.28 29.63 154.74 23.15 161.13 24.54 170.3 16.69 165.88 8.73 170.09 10.36 160.96 4.06 154.39 12.91 153.18 16.98 144.9",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "49.47 134.13 53.31 142.51 62.13 143.96 55.64 150.36 57.03 159.53 49.19 155.1 41.22 159.32 42.86 150.19 36.55 143.62 45.4 142.4 49.47 134.13",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "50.72 102.24 54.56 110.61 63.38 112.07 56.9 118.46 58.29 127.64 50.44 123.21 42.48 127.42 44.11 118.29 37.81 111.72 46.66 110.51 50.72 102.24",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "83.09 100.94 86.93 109.32 95.75 110.78 89.27 117.17 90.65 126.34 82.81 121.92 74.85 126.13 76.48 117 70.17 110.44 79.03 109.22 83.09 100.94",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "82.68 131.13 86.52 139.5 95.34 140.96 88.86 147.35 90.25 156.52 82.4 152.1 74.44 156.31 76.07 147.18 69.77 140.61 78.62 139.4 82.68 131.13",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "111.64 136.69 115.48 145.07 124.3 146.52 117.82 152.92 119.2 162.09 111.36 157.66 103.39 161.88 105.03 152.75 98.72 146.18 107.58 144.96 111.64 136.69",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "139.71 146.55 143.55 154.93 152.37 156.38 145.88 162.78 147.27 171.95 139.43 167.53 131.46 171.74 133.09 162.61 126.79 156.04 135.64 154.82 139.71 146.55",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "139.36 110.33 143.2 118.7 152.02 120.16 145.54 126.55 146.93 135.72 139.08 131.3 131.12 135.51 132.75 126.38 126.44 119.81 135.3 118.6 139.36 110.33",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "108.72 107.33 112.56 115.7 121.37 117.16 114.89 123.55 116.28 132.72 108.43 128.3 100.47 132.51 102.1 123.38 95.8 116.82 104.65 115.6 108.72 107.33",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "19.39 28.73 23.23 37.1 32.05 38.56 25.57 44.95 26.96 54.13 19.11 49.7 11.15 53.91 12.78 44.78 6.47 38.22 15.33 37 19.39 28.73",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "51.58 12.27 55.42 20.65 64.23 22.1 57.75 28.5 59.14 37.67 51.29 33.24 43.33 37.46 44.97 28.32 38.66 21.76 47.51 20.54 51.58 12.27",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "80.6 8.47 84.44 16.85 93.26 18.3 86.78 24.7 88.16 33.87 80.32 29.44 72.36 33.65 73.99 24.52 67.68 17.96 76.53 16.74 80.6 8.47",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "110.08 19.56 113.92 27.94 122.74 29.39 116.25 35.78 117.64 44.96 109.8 40.53 101.83 44.74 103.47 35.61 97.16 29.05 106.01 27.83 110.08 19.56",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "139.88 23.41 143.72 31.79 152.54 33.24 146.06 39.63 147.45 48.81 139.6 44.38 131.64 48.59 133.27 39.46 126.97 32.9 135.82 31.68 139.88 23.41",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "19.02 56.32 22.86 64.7 31.68 66.15 25.2 72.55 26.59 81.72 18.74 77.29 10.78 81.5 12.41 72.38 6.11 65.81 14.96 64.59 19.02 56.32",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "50.7 41.42 54.54 49.8 63.35 51.26 56.87 57.65 58.26 66.82 50.41 62.4 42.45 66.61 44.09 57.48 37.78 50.91 46.63 49.7 50.7 41.42",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "81.19 40.67 85.03 49.05 93.85 50.5 87.37 56.9 88.75 66.07 80.91 61.64 72.94 65.85 74.58 56.72 68.27 50.16 77.13 48.94 81.19 40.67",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "139.34 52.76 143.18 61.14 151.99 62.59 145.51 68.99 146.9 78.16 139.05 73.73 131.09 77.95 132.72 68.82 126.42 62.25 135.27 61.03 139.34 52.76",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "108.69 49.76 112.53 58.14 121.35 59.59 114.86 65.99 116.25 75.16 108.41 70.73 100.44 74.95 102.08 65.82 95.77 59.25 104.62 58.03 108.69 49.76",
    style: {
      fill: "#fff"
    }
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFlagTransition, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flag-transition.6b4c4b86.svg";
export { ForwardRef as ReactComponent };